import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { formatPhoneNumber } from "@/core/utils/phone";
import { IPayout } from "@/payouts/payouts";

export const ReferralCol = (): ColumnDef<IPayout> => ({
  header: "Referral",
  accessorFn: (row) =>
    row?.referral?.potential_customer_name ||
    formatPhoneNumber(row?.referral?.potential_customer_phone_number),
  cell: ({ getValue }) => {
    const value = getValue() as string;

    return (
      <LineClampedTooltip>
        {value || "No referral for payout"}
      </LineClampedTooltip>
    );
  },
});
